import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import styles from './styles.module.scss';
import { displayRtowNoText, displayCabinInfo, displayLuggageInfo } from '@utils/formatDisplay';
import { formatHour } from '@utils/formatDisplay';
import cN from 'classnames';


import { I_ItineraryInfo, I_FareInfo } from '@interfaces/common';
import { AirPlaneIcon, OclockIcon } from '@features/ui/Icons';
import TransferInfo from './TransferInfo';
import SegmentInfo from './SegmentInfo';
import { I_FareInfos } from '@Redux/search/interfaces';

interface I_FlightDetailsProps {
    fareInfos: I_FareInfos[];
    itineraryInfo: I_ItineraryInfo;
    isTF: boolean;
    seqNo: number;
}

const FlightDetailCard = ({ fareInfos, itineraryInfo, isTF, seqNo }: I_FlightDetailsProps) => {
    const { UrlParams } = useSelector((state: RootState) => state.search);

    return (
        <div className={styles.flightDetails}>
            <div className={styles.place}>
                <div className={styles.to}>
                    <div className={styles.segTag}>
                        {displayRtowNoText(itineraryInfo.SeqNo, UrlParams.Rtow)}
                    </div>
                    <div className={styles.flightTo}>
                        {itineraryInfo.DepCityName}
                        <AirPlaneIcon />
                        {itineraryInfo.ArrCityName}
                    </div>
                </div>
                <div className={styles.dur}>
                    <OclockIcon fill="#666" />
                    <span>總旅程時間：</span>
                    {formatHour(itineraryInfo.TotalFlyDuration)}
                </div>
            </div>

            <div className={styles.seqmentWrap}>
                {itineraryInfo.SegmentInfos.map((segmentInfo, i) => {
                    const cabinInfo = !isTF
                        ? displayCabinInfo(fareInfos, itineraryInfo.SeqNo, segmentInfo.SegSeqNo)
                        : null;

                    const luggageInfo = displayLuggageInfo(
                        fareInfos,
                        itineraryInfo.SeqNo,
                        segmentInfo.SegSeqNo
                    );

                    // 轉機停留
                    // 【排除】 沒有換飛機 && 轉機停留時間為 null
                    const hasTransfer =
                        segmentInfo.IsStopWait === false &&
                        !!segmentInfo.TransferDuration;


                    // 中途停留
                    // 轉機類別是否為【中途停留】 - 檢查第二筆之後就好 (取前一筆的中停資料，在該筆填入資料)
                    const hasStopWait = i > 0 && segmentInfo.IsStopWait;

                    // 更換航廈、機場顯示文字
                    const transferType = () => {
                        if (i === 0) return null;
                        const SegmentInfos = itineraryInfo?.SegmentInfos
                        const AirportDesc = SegmentInfos[i].AirportDesc
                        const isHightLight = SegmentInfos[i].AirportHighlight
                        if (SegmentInfos[i - 1]?.ArrAirport !== SegmentInfos[i]?.DepAirport) return { AirportDesc, isHightLight }
                        if (SegmentInfos[i - 1]?.ArrTerminal !== SegmentInfos[i]?.DepTerminal) return { AirportDesc, isHightLight }
                        return { AirportDesc, isHightLight }
                    }

                    const transferSituation = transferType();

                    return (
                        <React.Fragment key={`${seqNo}-${itineraryInfo.SeqNo}-${segmentInfo.SegSeqNo}-${i}`}>
                            {hasTransfer && (
                                <TransferInfo index={i} segmentInfos={itineraryInfo.SegmentInfos} transferSituation={transferSituation} />
                            )}

                            {hasStopWait &&
                                <div className={cN(styles.transfer)}>
                                    <span>
                                        {transferSituation?.AirportDesc}
                                    </span>
                                    <span className={styles.icon}>
                                        <OclockIcon />
                                    </span>
                                    <span className={styles.notice}>
                                        <span>{itineraryInfo.SegmentInfos[i].TransferDuration}</span>
                                    </span>
                                </div>
                            }

                            <SegmentInfo
                                segmentInfo={segmentInfo}
                                luggageInfo={luggageInfo}
                                cabinInfo={cabinInfo}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default FlightDetailCard;
